import { render, staticRenderFns } from "./ModificarDenuncia.vue?vue&type=template&id=31a25837"
import script from "./ModificarDenuncia.vue?vue&type=script&lang=js"
export * from "./ModificarDenuncia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports